
<template>
	<div class="page-container">
		<HeaderLayout></HeaderLayout>
		<div class="content">
		    <div class="main-content">
				<h2 class="text-name">이용약관</h2>
				<div class="agreeText" v-html="agreeContent"></div>
			</div>
		</div>
		<FooterLayout></FooterLayout>
	</div>	
	
</template>

<script>
import HeaderLayout from '@/components/inc/Header'
import FooterLayout from '@/components/inc/Footer'

export default {
  name: 'PageAgree',
  components: {
	  HeaderLayout,
	  FooterLayout,
  },
  data () {
	
	return {
  	   agreeContent:'',
	   
	   
   }
  },
  created: function() {
	
	  this.getData();
  },
  methods: {
	   getData() {  
			var obj = this;
			this.$form.sendPost({},'memberProc/getAgreeInfo',function(response) {
				 obj.agreeContent = response.agreeInfo.agree1;
			});	
	  },
	 

  },
  mounted: function() {

	$('.main-content').css('min-height',$(window).height());
	
	
  },
  updated() {
		
	
  }

}
</script>

<style lang="scss" scoped>

.page-container {
	width:100%;
	background:#fff;
	margin:0;
	min-height:calc(100vh);
	.content {
		width:100%;
		height:auto;
		padding:150px 0 100px; 
		font-family: 'Nanum Gothic', sans-serif;
		background:#fff;
		.main-content {
			width:830px;
			margin:0 auto;
			.text-name {
				font-size:26px;
				font-weight:normal;
				color:#414141;
				line-height:100%;
				margin-bottom:0;
			}
			.agreeText {
				height:700px;
				overflow-x:hidden;
				overflow-y:auto;
				padding:10px;
				margin-top:20px;
				border:solid 1px #dcdcdc;
			}
		}	
	}
	
}


</style>